import React from 'react';

import { Skeleton } from '~/atomic/atom/Skeleton';

import {
  SCBottomPostCard,
  SCMainPostCard,
  SCPostCard,
} from './postCardStyle';

export const EmptyPostCard = () => {
  return (
    <SCPostCard>
      <SCMainPostCard>
        <Skeleton
          active
          title
          paragraph={{ rows: 3 }}
        />
      </SCMainPostCard>
      <SCBottomPostCard>
        <Skeleton
          active
          title
          paragraph={{ rows: 0 }}
        />
      </SCBottomPostCard>
    </SCPostCard>
  );
};
